const _serviceDependencies = ['$scope', '$state'];

class DwmUpsell {

    constructor($scope, $state) {

        $scope.buy = (appId) => {

            appId = 'adwp1';
            // const mixpanelData = {
            //     'Product ID': appId,
            //     Page: 'AIA Store Page',
            //     Runtimes: 12,
            // };

            // Mixpanel.send('ConnectWeb Store Buy Click', mixpanelData);

            const subsource = 'store';

            $state.go('root.dashboard.dwm.ltb.buy', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource,
            }, {
                reload: false,
            });

        };

    }

}

_serviceDependencies.push(DwmUpsell);

angular.module('controllers')
    .controller('DwmUpsell', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/dwm-upsell/dwm-upsell.js